import {
    Box,
    Divider,
    Flex,
    HStack,
    Avatar,
    CloseButton,
} from '@chakra-ui/react';
import { Button } from '@/components/v4';
import Text from 'components/v4/Text';

/**
 * Generic placeholder user-edit-drawer content for platforms that don't yet
 * have real user management UI (RingCentral, DialPad, and any future platform
 * in the same phase — see GENERIC_SIMPLE_SERVICE_PROFILE_PLATFORMS in
 * services/platformRegistry.js). Replaces the previous per-platform
 * RingCentralUserEditContent/DialPadUserEditContent, which were identical
 * aside from the display name.
 */
const GenericPlatformUserEditContent = ({
    displayName,
    selectedPlatform,
    onClose,
    onSave,
    darkMode,
}) => {
    const userDisplayName =
        [selectedPlatform?.firstName, selectedPlatform?.lastName]
            .filter(Boolean)
            .join(' ') ||
        selectedPlatform?.displayName ||
        `${displayName} User`;

    const borderColor = darkMode ? 'dark.tcap-borderGray' : 'gray.200';

    return (
        <Flex direction="column" h="100%" gap={0}>
            <Flex
                align="center"
                justify="space-between"
                px={6}
                py={4}
                borderBottomWidth="1px"
                borderColor={borderColor}>
                <HStack spacing={3}>
                    <Avatar
                        size="md"
                        bg="messenger.500"
                        color="white"
                        name={userDisplayName}
                    />
                    <Box>
                        <Text
                            fontWeight="700"
                            fontSize="lg"
                            marginBottom={0}
                            color={darkMode ? 'white' : 'gray.800'}>
                            {userDisplayName}
                        </Text>
                        {selectedPlatform?.email && (
                            <Text
                                fontSize="sm"
                                color="gray.500"
                                marginBottom={0}>
                                {selectedPlatform.email}
                            </Text>
                        )}
                    </Box>
                </HStack>
                <CloseButton
                    size="md"
                    onClick={onClose}
                    color={darkMode ? 'white' : 'gray.600'}
                />
            </Flex>

            <Box flex="1" overflowY="auto" px={6} py={6}>
                <Text
                    color={darkMode ? 'gray.300' : 'gray.500'}
                    marginBottom={0}>
                    {displayName} user management — to be matured in a future
                    release.
                </Text>
            </Box>

            <Divider />

            <Flex px={6} py={4} gap={3}>
                <Button onClick={onSave}>Save</Button>
                <Button variant="outline" onClick={onClose}>
                    Cancel
                </Button>
            </Flex>
        </Flex>
    );
};

export default GenericPlatformUserEditContent;
